import { render, staticRenderFns } from "./setRiskReject.vue?vue&type=template&id=79caf4c1&"
import script from "./setRiskReject.vue?vue&type=script&lang=js&"
export * from "./setRiskReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79caf4c1')) {
      api.createRecord('79caf4c1', component.options)
    } else {
      api.reload('79caf4c1', component.options)
    }
    module.hot.accept("./setRiskReject.vue?vue&type=template&id=79caf4c1&", function () {
      api.rerender('79caf4c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setRiskReject.vue"
export default component.exports